import Vue from "vue";
import {deepCopyObject} from "./utility/util";
import wsMqtt from './wsMqtt.js'

const querystring = require('querystring')
const baseUrl = `https://${process.env.VUE_APP_HOST}/codeupdate/api`;

const projectList = [
    {
        projectId: '01',
        projectName: '咻电共享充电宝'
    },
    {
        projectId: '02',
        projectName: '幽电共享充电宝'
    },
    {
        projectId: '03',
        projectName: '嗨电共享充电宝'
    },
    {
        projectId: '04',
        projectName: '猛电共享充电宝'
    },
    {
        projectId: '05',
        projectName: '电小童共享充电宝'
    },
    {
        projectId: '06',
        projectName: '优学者共享充电宝'
    },
    {
        projectId: '07',
        projectName: '盒力充共享充电宝'
    },
    {
        projectId: '08',
        projectName: '电小童机柜主机'
    },
    {
        projectId: '09',
        projectName: '电小童机柜副机'
    },
    {
        projectId: '10',
        projectName: '猛电机柜主机'
    },
    {
        projectId: '11',
        projectName: '猛电机柜副机'
    },
    {
        projectId: '12',
        projectName: '壹小宝共享充电宝'
    },
    {
        projectId: '13',
        projectName: '壹小宝机柜主机'
    },
    {
        projectId: '14',
        projectName: '壹小宝机柜副机'
    },
    {
        projectId: '15',
        projectName: '尚岛共享充电宝'
    },
    {
        projectId: '16',
        projectName: '众云共享充电宝'
    },
    {
        projectId: '17',
        projectName: '来客共享充电宝'
    },
    {
        projectId: '18',
        projectName: '众云机柜主机'
    },
    {
        projectId: '19',
        projectName: '众云机柜副机'
    },
    {
        projectId: '20',
        projectName: '安享共享充电宝'
    },
    {
        projectId: '21',
        projectName: '速电共享充电宝'
    },
    {
        projectId: '22',
        projectName: '应急电源主机'
    },
    {
        projectId: '23',
        projectName: '应急电源副机'
    },
    {
        projectId: '24',
        projectName: '速电挂壁式汽车充电桩'
    },
    {
        projectId: '25',
        projectName: '前巍电机双枪充电桩'
    },
    {
        projectId: '26',
        projectName: '前巍电机单枪充电桩'
    },
    {
        projectId: '27',
        projectName: '前巍电机三相充电桩'
    }];

let updateInfo = {
    codeId: '',
    startDeviceId: '',
    endDeviceId: '',
    projectId: '',
    projectName: '',
    codeString: '',
};

let updateResult = {
    logString: '',
    searchSetting: {
        startDeviceId: '',
        endDeviceId: '',
        projectId: ''
    },
    resultList: []
};

let user = {
    username: '',
    password: ''
};

function upload(formData, callback) {
    let url = baseUrl + '/upload';
    Vue.http.post(url, formData).then(response => {
        if (callback) {
            callback('success', response.bodyText);
        }
    }, response => {
        if (callback) {
            let errorMsg = '';
            if (response.status >= 400) {
                errorMsg = '固件升级信息上传失败';
            } else {
                errorMsg = '服务器未响应上传请求';
            }
            callback('fail', errorMsg);
        }
    });
}

function checkUser(user, callback) {
    let userString = querystring.stringify(user);
    // window.console.log(userString);
    let url = baseUrl + '/login';
    Vue.http.post(url, userString).then(() => {
        if (callback) {
            callback('success', 'ok');
        }
    }, response => {
        if (callback) {
            let errorMsg = '';
            if (response.status >= 400) {
                errorMsg = '账号或密码错误';
            } else {
                errorMsg = '服务器未响应登录请求';
            }
            callback('fail', errorMsg);
        }
    });
}

function getLastRecord(callback) {
    let url = baseUrl + '/lastRecord';
    Vue.http.post(url).then(response => {
        if (callback) {
            if (response.bodyText) {
                callback('success', response.bodyText);
            } else {
                callback('fail', '没有最近一次上传记录');
            }
        }
    }, response => {
        if (callback) {
            let errorMsg = '';
            if (response.status >= 400) {
                errorMsg = '获取最近一次上传记录失败';
            } else {
                errorMsg = '服务器未响应登录请求';
            }
            callback('fail', errorMsg);
        }
    });
}

//获取设备升级结果
//参数config指定projectId，startDeviceId和endDeviceId
function getResultList(config, callback) {
    let url = baseUrl + '/getResultList';
    let dataString = JSON.stringify(config);
    Vue.http.post(url, dataString).then(response => {
        console.log(response.data);
        let list = response.data;              //当前页面中的记录数据
        //去除同一设备多次更新的情况
        this.updateResult.resultList = list;

        if (callback) {
            callback('success');
        }
    }, response => {
        console.log(response.data);
        if (callback) {
            callback('fail', response.data);
        }
    });
}

function resetUpdateInfo() {
    console.log('updateInfo', updateInfo);
    console.log('this.updateInfo', this.updateInfo);
    deepCopyObject(this.updateInfo, updateInfo);
}

function initMqtt() {
    wsMqtt.init(this.updateInfo, this.updateResult);
}

export default {
    projectList,
    user,
    updateInfo,
    updateResult,
    checkUser,
    upload,
    resetUpdateInfo,
    getLastRecord,
    getResultList,
    initMqtt
}